import script from "./unidentified.vue?vue&type=script&setup=true&lang=ts"
export * from "./unidentified.vue?vue&type=script&setup=true&lang=ts"

import "./unidentified.vue?vue&type=style&index=0&id=67aebd24&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67aebd24"]])

export default __exports__